import React from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import {fetchFromHub} from "../../actions/networkActions";
import {getTranslation} from '../../translations/translationUtils';
import OverviewImageButtonPanel from '../../components/OverviewImageButtonPanel';
import OverviewImageButton from "../../components/OverviewImageButton.js";
import {setWayfinderProfiles} from "../../actions/wayfinderActions";
import FullScreenLoader from '../../components/FullScreenLoader.js';

class DiningOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            loaded: false,
        }
    }

    componentDidMount() {
        this.props.fetchFromHub(`dining`, this.update);
    }

    update = (restaurants) => {
        if(this.props.configuration.hubSettings.enableWayfinder) {
            const wayfinderProfileIds = restaurants
                .filter(restaurant => restaurant.wayfinderProfile)
                .map(restaurant => restaurant.wayfinderProfile.id);

            setWayfinderProfiles(wayfinderProfileIds);
        }

        this.setState({
            items: restaurants,
            loaded: true,
        });
    };


    render() {
        if (!this.state.loaded) {
            return <FullScreenLoader />
        }

        if (this.state.items.length === 0) {
            return ( <div>{this.context.t("no_restaurants_available")}</div>);
        }

        return (
            <div>
                <OverviewImageButtonPanel>
                    {this.state.items.map((item) => {
                        const title = getTranslation(item.title);
                        const thumbnailUrl = `${this.props.configuration.hubUrl}blobs/image?reference=${item.id}&width=400`;
                        const itemUrl = `/dining/detail/${item.id}` ;
                        const bookable = item.externalId ? true : false;

                        return (
                            <OverviewImageButton
                                heightWidthRatio="100%"
                                truncateTitle={true}
                                key={item.id}
                                link={itemUrl}
                                title={title}
                                thumbnail={thumbnailUrl}
                                bookable={bookable}
                            />);
                    })}
                </OverviewImageButtonPanel>
            </div>
        );
    }
}

DiningOverview.contextTypes = {
    t: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    // lang used to trigger rerender in new language when changed
    return {
        configuration: state.configuration,
        lang: state.i18nState.lang
    };
};


export default connect(mapStateToProps, {fetchFromHub: fetchFromHub})(DiningOverview);